module.exports = __webpack_public_path__ + "img/组 23@2x.536ef595.png";